export default __webpack_public_path__ + "static/media/infrastructure.0b84919f.svg";